<template>
	<tr class="tableTr">
		<td class="dense" :class="{'tdGreen': checkClasses['filter_id']}">{{ item.id }}</td>
		<td :class="{'tdGreen': checkClasses['filter_date']}">{{ onFormatDate(item['date']) }}</td>
		<td :class="{'tdGreen': checkClasses['filter_truck_number']}">
			<span
					@click="onLink({flag:'trucks', id:item['truck_id'], permissions: linksPermissions['3']['10']})"
					:class="{'link': linksPermissions['3']['10']}">{{ item['truck_number'] }}</span>
		</td>
		<td width="170" class="center dense" :class="{'tdGreen': checkClasses['filter_company_owned']}">
			<svg-sprite
					:style="`color: ${ Boolean(item.company_owned) ? '#19BC38' : '#8F90A6'}`"
					height="20"
					width="20"
					:icon-id="`st_${item.company_owned ? 'true': 'false'}`"
			></svg-sprite>
		</td>
		<td class="dense" :class="{'tdGreen': checkClasses['filter_customer']}">
			<span
					@click="onLink({flag:'customers', id:item['division_id'], permissions: linksPermissions['6']['10']})"
					:class="{'link': linksPermissions['6']['10']}">{{ item['customer'] }}</span>
		</td>
		<td :class="{'tdGreen': checkClasses['filter_driver']}">
			<span
					@click="onLink({flag:'drivers', id:item['driver_id'], permissions: linksPermissions['5']['10']})"
					:class="{'link': linksPermissions['5']['10']}">{{ item['driver'] }}</span>
		</td>
		<td :class="{'tdGreen': checkClasses['filter_driver_type']}">{{ item['driver_type'] }}</td>
		<td :class="{'tdGreen': checkClasses['filter_reason']}">
			<div class="groupField_wrap">
				<div :style="'background:' + getIndicatorColor" class="indicator"></div>
				<field
						margin="0"
						padding="0"
						width="100%"
						:autocompleteValue="item['reason_id']"
						@updateSelect="onEditDynamic($event, 'reason_id')"
						:items="reason"
						:isClearable="false"
						is-select
						is-off-style
				></field>
			</div>
		</td>
		<td :class="{'tdGreen': checkClasses['filter_description']}">
			<field
					placeholder="Enter description"
					:setInputValue="item['description']"
					@updateInput="onEditDynamic($event, 'description')"
					:tooltip="item['description']"
					is-off-style
			></field>
		</td>
		<td width="90">
			<div class="btnGroups">
				<!--                <button disabled type="button" @click="onEdit">
														<svg-sprite style="color: #8F90A6" icon-id="edit" width="18" height="18"></svg-sprite>
												</button>-->
				<button :disabled="!permissions['11']" type="button" @click="onRemove">
					<svg-sprite icon-id="deleteItem" width="20" height="20"></svg-sprite>
				</button>
			</div>
		</td>
	</tr>
</template>

<script>
import { mapActions } from "vuex";
// helpers
import { formatCurrency, formatDate } from "@/helper";

export default {
	name: "TableTr",
	props: {
		item: Object,
		permissions: Object,
		linksPermissions: Object,
		checkClasses: Object,
		reason: Array,
		filterClassesActive: Function,
		idx: Number
	},
	computed: {
		getIndicatorColor() {
			const item = this.reason.find(item => item.id === this.item['reason_id']);
			return item?.color ?? '';
		}
	},
	methods: {
		...mapActions([ 'onTrucksRoadEditDynamic' ]),
		onFormatDate(date) {
			return formatDate(date);
		},
		getIconColor(value) {
			const color = value ? '#19BC38' : '#8F90A6';
			return `color: ${ color }`;
		},
		onLink(args) {
			const { flag, id, permissions } = args;
			if (permissions) this.$emit('updateLink', { flag, id });
		},
		onEdit() {
			this.$emit('updateEdit', this.item.id);
		},
		onRemove() {
			this.$emit('updateRemoveItem', this.item.id);
		},
		getTotal(total) {
			return formatCurrency(total);
		},
		onCommentsPopup() {
			const { id, unit, unit_type } = this.item;
			this.$emit('updateCommentsPopup', { id, unit, unit_type });
		},
		async onEditDynamic({ value }, key) {
			const { reason_id, description, id } = this.item;
			const values = {
				id,
				reason_id,
				description
			};

			values[key] = value.id ?? value;
			await this.onTrucksRoadEditDynamic(values);
			this.$emit('updateFilterList');
		}
	}
};
</script>

<style lang="scss" scoped>
@import "tableTr";

.btnGroups {
	justify-content: center;
}
</style>

<style lang="scss">
@import "tableTrGlobal";
</style>
